import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ApartmentOutlined, ClusterOutlined, ControlOutlined, FolderOutlined, MailOutlined, SettingOutlined, TeamOutlined } from '@ant-design/icons';
import { CARE_PLANS_PATH, MEMBERS_PATH, TASKS_PATH, PROVIDERS_PATH, ORGANIZATION_GROUPS_PATH, THIRD_PARTY_ADMINS_PATH, TEAMS_PATH, LIBRARY_PATH, PERMISSION_AUDIT_LOGS_PATH, QUEUE_SYSTEM_AUDIT_LOGS_PATH, QUEUE_SYSTEM_SETTINGS_PATH, QUEUES_PATH, INTAKE_GROUPS_PATH, ADVOCATE_PROFILES_PATH, INVITES_PATH, TICKET_SETTINGS_PATH, SURVEYS_PATH, ARTICLE_CATEGORIES_PATH, BENEFIT_CMS_SETTINGS_PATH, CARE_PODS_PATH } from 'constants/routes';
import { SUBJECTS } from 'context/Permissions/abilities';
import ChatLink from 'components/LeftNav/ChatLink';
import TaskLink from 'components/LeftNav/TaskLink';
import ticketsIcon from 'assets/tickets.svg';
import tasksIcon from 'assets/tasks.svg';
import chatsIcon from 'assets/chats.svg';
import membersIcon from 'assets/members.svg';
import providersIcon from 'assets/providers.svg';
import facilitiesIcon from 'assets/facilities.svg';
import organizationsIcon from 'assets/organizations.svg';
import carePlansIcon from 'assets/care_plans.svg';
import billAdvocacyIcon from 'assets/bill_advocacy.svg';
import benefitCmsIcon from 'assets/benefit_cms.svg';
import pharmacyPlansIcon from 'assets/pharmacy_plans.svg';
import libraryIcon from 'assets/library.svg';
import metabaseIcon from 'assets/metabase.svg';
import queuesIcon from 'assets/queues.svg';
import tagsIcon from 'assets/tags.svg';
import queueLogsIcon from 'assets/queue_logs.svg';
import teamProfilesIcon from 'assets/team_profiles.svg';
import teamsIcon from 'assets/teams.svg';
import organizationGroupsIcon from 'assets/organization_groups.svg';
import permissionLogsIcon from 'assets/permission_logs.svg';
export var NavIcon = function (_a) {
    var src = _a.src;
    return (_jsx("span", { className: "anticon", style: {
            display: 'inline-block',
            width: 16,
            height: 16,
            backgroundColor: 'currentColor',
            maskImage: "url(".concat(src, ")"),
            WebkitMaskImage: "url(".concat(src, ")"),
            maskSize: 'contain',
            WebkitMaskSize: 'contain',
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat',
            maskPosition: 'center',
            WebkitMaskPosition: 'center'
        } }));
};
export var MY_WORK_LINKS = [
    {
        pathTo: '/tickets',
        dataTest: 'leftNavTicketsPage',
        title: 'Tickets',
        icon: _jsx(NavIcon, { src: ticketsIcon })
    },
    {
        pathTo: TASKS_PATH,
        dataTest: 'leftNavTasksPage',
        title: 'Tasks',
        render: TaskLink,
        icon: _jsx(NavIcon, { src: tasksIcon })
    },
    {
        pathTo: '/chats',
        dataTest: 'leftNavChats',
        title: 'Chats',
        render: ChatLink,
        icon: _jsx(NavIcon, { src: chatsIcon })
    }
];
export var DIRECTORY_LINKS = [
    {
        pathTo: MEMBERS_PATH,
        dataTest: 'leftNavMemberInfo',
        title: 'Members',
        icon: _jsx(NavIcon, { src: membersIcon })
    },
    {
        pathTo: PROVIDERS_PATH,
        dataTest: 'leftNavProviders',
        title: 'Providers',
        icon: _jsx(NavIcon, { src: providersIcon })
    },
    {
        pathTo: '/facilities',
        dataTest: 'leftNavFacilities',
        title: 'Facilities',
        icon: _jsx(NavIcon, { src: facilitiesIcon })
    },
    {
        pathTo: '/organizations',
        dataTest: 'leftNavOrganizations',
        title: 'Organizations',
        icon: _jsx(NavIcon, { src: organizationsIcon })
    }
];
export var MEMBER_TOOLS_LINKS = [
    {
        pathTo: CARE_PLANS_PATH,
        dataTest: 'leftNavCarePlans',
        title: 'Care plans',
        icon: _jsx(NavIcon, { src: carePlansIcon })
    },
    {
        pathTo: '/bill-advocacy',
        dataTest: 'leftNavBillAdvocacy',
        permissionSubject: SUBJECTS.ClAIMS,
        title: 'Bill advocacy',
        icon: _jsx(NavIcon, { src: billAdvocacyIcon })
    }
];
export var RESOURCES_LINKS = [
    {
        pathTo: '/benefits-cms',
        dataTest: 'leftNavBenefitsCms',
        title: 'Benefits CMS',
        icon: _jsx(NavIcon, { src: benefitCmsIcon })
    },
    {
        pathTo: '/pharmacy-plans',
        dataTest: 'leftNavPharmacyPlans',
        permissionSubject: SUBJECTS.PHARMACY_PLANS,
        title: 'Pharmacy plans',
        icon: _jsx(NavIcon, { src: pharmacyPlansIcon })
    },
    {
        pathTo: LIBRARY_PATH,
        dataTest: 'leftNavLibrary',
        permissionSubject: SUBJECTS.LIBRARY,
        title: 'Library',
        icon: _jsx(NavIcon, { src: libraryIcon })
    }
];
export var METABASE_ITEM = {
    dataTest: 'leftNavMetabase',
    title: 'Metabase',
    icon: _jsx(NavIcon, { src: metabaseIcon })
};
export var OPERATIONS_LINKS = [
    {
        pathTo: INTAKE_GROUPS_PATH,
        dataTest: 'leftNavIntakeGroups',
        permissionSubject: SUBJECTS.INTAKE_GROUP,
        title: 'Intake groups',
        icon: _jsx(TeamOutlined, {})
    },
    {
        pathTo: QUEUES_PATH,
        dataTest: 'leftNavQueues',
        permissionSubject: SUBJECTS.INTAKE_QUEUE,
        title: 'Queues',
        icon: _jsx(NavIcon, { src: queuesIcon })
    },
    {
        pathTo: '/tags',
        dataTest: 'leftNavTags',
        permissionSubject: SUBJECTS.INTAKE_TAG,
        title: 'Tags',
        icon: _jsx(NavIcon, { src: tagsIcon })
    },
    {
        pathTo: QUEUE_SYSTEM_AUDIT_LOGS_PATH,
        dataTest: 'leftNavQueueSystemAuditLog',
        permissionSubject: SUBJECTS.INTAKE_QUEUE,
        title: 'Queue logs',
        icon: _jsx(NavIcon, { src: queueLogsIcon })
    },
    {
        pathTo: QUEUE_SYSTEM_SETTINGS_PATH,
        dataTest: 'leftNavQueueSystemSettings',
        permissionSubject: SUBJECTS.INTAKE_QUEUE,
        title: 'Queue settings',
        icon: _jsx(ControlOutlined, { style: { fontSize: 16 } })
    }
];
export var ADMIN_LINKS = [
    {
        pathTo: ARTICLE_CATEGORIES_PATH,
        dataTest: 'leftNavArticleCategories',
        permissionSubject: SUBJECTS.ADMIN,
        title: 'Article categories',
        icon: _jsx(FolderOutlined, { style: { fontSize: 16 } })
    },
    {
        pathTo: BENEFIT_CMS_SETTINGS_PATH,
        dataTest: 'leftNavBenefitCmsSettings',
        permissionSubject: SUBJECTS.ADMIN,
        title: 'Benefit CMS settings',
        icon: _jsx(NavIcon, { src: benefitCmsIcon })
    },
    {
        pathTo: CARE_PODS_PATH,
        dataTest: 'leftNavCarePods',
        permissionSubject: SUBJECTS.ADMIN,
        title: 'Care pods',
        icon: _jsx(ApartmentOutlined, { style: { fontSize: 16 } })
    },
    {
        pathTo: INVITES_PATH,
        dataTest: 'leftNavInvites',
        permissionSubject: SUBJECTS.INVITES,
        title: 'Invites',
        icon: _jsx(MailOutlined, { style: { fontSize: 16 } })
    },
    {
        pathTo: ORGANIZATION_GROUPS_PATH,
        dataTest: 'leftNavOrganizationGroups',
        permissionSubject: SUBJECTS.ORGANIZATION_GROUPS,
        title: 'Organization groups',
        icon: _jsx(NavIcon, { src: organizationGroupsIcon })
    },
    {
        pathTo: THIRD_PARTY_ADMINS_PATH,
        dataTest: 'leftNavPartnerships',
        permissionSubject: SUBJECTS.ADMIN,
        title: 'Partnerships',
        icon: _jsx(ClusterOutlined, { style: { fontSize: 16 } })
    },
    {
        pathTo: PERMISSION_AUDIT_LOGS_PATH,
        dataTest: 'leftNavPermissionAuditLogs',
        permissionSubject: SUBJECTS.TEAMS,
        title: 'Permission logs',
        icon: _jsx(NavIcon, { src: permissionLogsIcon })
    },
    {
        pathTo: ADVOCATE_PROFILES_PATH,
        dataTest: 'leftNavAdvocateProfiles',
        permissionSubject: SUBJECTS.USERS,
        title: 'Team profiles',
        icon: _jsx(NavIcon, { src: teamProfilesIcon })
    },
    {
        pathTo: TEAMS_PATH,
        dataTest: 'leftNavTeams',
        permissionSubject: SUBJECTS.TEAMS,
        title: 'Teams',
        icon: _jsx(NavIcon, { src: teamsIcon })
    },
    {
        pathTo: SURVEYS_PATH,
        dataTest: 'leftNavSurveys',
        permissionSubject: SUBJECTS.SURVEYS,
        title: 'Surveys',
        icon: _jsx(SettingOutlined, { style: { fontSize: 16 } })
    },
    {
        pathTo: TICKET_SETTINGS_PATH,
        dataTest: 'leftNavTicketSettings',
        permissionSubject: SUBJECTS.TICKET_SETTINGS,
        title: 'Ticket settings',
        icon: _jsx(SettingOutlined, { style: { fontSize: 16 } })
    }
];
